<template>
  <div v-if="isMobileScreenSize" class="flex flex-col flex-1 w-full gap-24">
    <H2 class="font-semibold">{{
      $t('health_actions.scheduling.select_doctor_preferences_title')
    }}</H2>
    <div class="flex flex-col gap-24">
      <div class="flex flex-col gap-8 flex-1">
        <Body class="text-grey-500 font-semibold">
          {{ $t('health_actions.scheduling.select_doctor_distance') }}
        </Body>
        <div class="flex border border-grey-300 rounded p-16">
          <select
            class="w-full justify-between"
            @change="(e) => setDoctorPreferences({ distance: e.target.value })"
          >
            <option value="">
              {{ $t('common.select') }}
            </option>
            <option
              v-for="option in distanceOptions"
              :key="option.value"
              :value="option.value"
              :selected="option.value === getDoctorPreferences.distance"
            >
              {{ option.text }}
            </option>
          </select>
        </div>
      </div>
      <div class="flex flex-col gap-8 flex-1">
        <Body class="text-grey-500 font-semibold">
          {{ $t('health_actions.scheduling.select_doctor_gender') }}
        </Body>
        <div class="flex border border-grey-300 rounded p-16">
          <select
            class="w-full justify-between"
            @change="(e) => setDoctorPreferences({ gender: e.target.value })"
          >
            <option value="">
              {{ $t('common.select') }}
            </option>
            <option
              v-for="option in genderOptions"
              :key="option.value"
              :value="option.value"
              :selected="option.value === getDoctorPreferences.gender"
            >
              {{ option.text }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="flex flex-col bg-grey-50 rounded-md p-16 justify-between">
      <div class="flex flex-row items-center">
        <InfoCircle class="w-24" />
        <p class="font-sans-bold ml-8">
          {{
            $t('health_actions.scheduling.select_doctor_distance_description')
          }}
          <span class="font-semibold">{{ zipCode }}</span>
        </p>
      </div>
      <p
        class="text-blue-500 font-semibold underline ml-25 pl-1 py-8 cursor-pointer"
        @click="showModal = true"
      >
        {{ $t('health_actions.scheduling.select_doctor_change_zip_code') }}
      </p>
    </div>
  </div>
  <div v-else class="flex flex-col flex-1 w-full gap-24">
    <H1 class="font-semibold text-3xl">{{
      $t('health_actions.scheduling.select_doctor_preferences_title')
    }}</H1>

    <div class="flex gap-24 flex-1 w-full">
      <div class="flex flex-col gap-8 flex-1">
        <Body class="text-grey-500 font-semibold">
          {{ $t('health_actions.scheduling.select_doctor_distance') }}
        </Body>
        <div class="flex border border-grey-300 rounded p-16">
          <select
            class="w-full justify-between"
            @change="(e) => setDoctorPreferences({ distance: e.target.value })"
          >
            <option value="">
              {{ $t('common.select') }}
            </option>
            <option
              v-for="option in distanceOptions"
              :key="option.value"
              :value="option.value"
              :selected="option.value === getDoctorPreferences.distance"
            >
              {{ option.text }}
            </option>
          </select>
        </div>
      </div>
      <div class="flex flex-col gap-8 flex-1">
        <Body class="text-grey-500 font-semibold">
          {{ $t('health_actions.scheduling.select_doctor_gender') }}
        </Body>
        <div class="flex border border-grey-300 rounded p-16">
          <select
            class="w-full justify-between"
            @change="(e) => setDoctorPreferences({ gender: e.target.value })"
          >
            <option value="">
              {{ $t('common.select') }}
            </option>
            <option
              v-for="option in genderOptions"
              :key="option.value"
              :value="option.value"
              :selected="option.value === getDoctorPreferences.gender"
            >
              {{ option.text }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div
      class="flex flex-row bg-grey-50 rounded-md p-16 items-center justify-between"
    >
      <div class="flex flex-row items-center">
        <InfoCircle class="w-24" />
        <p class="font-sans-bold ml-8">
          {{
            $t('health_actions.scheduling.select_doctor_distance_description')
          }}
          <span class="font-semibold">{{ zipCode }}</span>
        </p>
      </div>
      <p
        class="text-blue-500 font-semibold underline ml-8 cursor-pointer"
        @click="openZipCodeModal"
      >
        {{ $t('health_actions.scheduling.select_doctor_change_zip_code') }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Body from '~/components/common/Typography/Body.vue'
import H1 from '~/components/common/Typography/H1.vue'
import H2 from '~/components/common/Typography/H2.vue'
import H3 from '~/components/common/Typography/H3.vue'
import { InfoCircle } from '~/assets/svgs/index'
import Modal from '~/components/common/Modal.vue'
import HMButton from '~/components/common/forms/Button.vue'
import Drawer from '~/components/common/Drawer.vue'
import screenSizeMixin from '~/components/mixins/screenSizeMixin'
import doctorPreferencesMixin from './doctorPreferencesMixin'

export default {
  components: {
    H1,
    H2,
    H3,
    Body,
    InfoCircle,
    Modal,
    Drawer,
    HMButton,
  },
  mixins: [screenSizeMixin, doctorPreferencesMixin],
  data() {
    return {
      showModal: false,
      newZipCode: '',
    }
  },
  computed: {
    ...mapGetters('scheduling', ['getDoctorPreferences', 'zipCode']),
  },
  methods: {
    ...mapActions('scheduling', ['setDoctorPreferences', 'setZipCode']),
    openZipCodeModal() {
      this.$emit('open-zip-code-modal')
    },
    saveZipCode() {
      this.setZipCode(this.newZipCode)
      this.$emit('close-zip-code-modal')
    },
  },
}
</script>
